/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import ChoiceButtons from 'shared/ui/components/form-components/ChoiceButtons.vue';
import WizardStep from 'shared/ui/components/WizardStep.vue';

const __vue_script__ = {
    name: 'EventType',

    components: { ChoiceButtons, BaseInput },

    extends: WizardStep,

    data() {
        return {
            options: []
        };
    },

    watch: {
        form: {
            deep: true,
            immediate: true,
            async handler() {
                try {
                    if (!this.form.organization) {
                        return;
                    }

                    this.options = await this.$services.org.getCreationOptions(this.form.organization.name, this.form.audience_type);

                    if (this.form.event_classification !== 'other') {
                        this.form.event_custom_classification = null;
                    }
                } catch (error) {
                    console.error('[EventType] Could not load event\'s type options', error);
                }
            }
        },

    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"event-type",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"event_classification"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('choice-buttons',{attrs:{"name":"event_classification","options":_vm.options,"errors":errors,"wide":true},scopedSlots:_vm._u([{key:"choice",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"text"},[_vm._v(_vm._s(item.label))])]}}],null,true),model:{value:(_vm.form.event_classification),callback:function ($$v) {_vm.$set(_vm.form, "event_classification", $$v)},expression:"form.event_classification"}})]}}])}),(_vm.form.event_classification === 'other')?_c('base-input',{attrs:{"focused":_vm.focus === 'event_custom_classification',"label":_vm.$t('wizards.create_workspace.form.event_custom_classification'),"name":"event_custom_classification","type":"text"},model:{value:(_vm.form.event_custom_classification),callback:function ($$v) {_vm.$set(_vm.form, "event_custom_classification", $$v)},expression:"form.event_custom_classification"}}):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "EventType.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__